/**
 * Calculator Modal Component - Using new Modal component
 */
import React, { useState } from 'react';
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalTitle,
} from '../../components/ui/modal';
import { Button } from '../../components/ui/button';
import { Calculator } from 'lucide-react';
import { cn } from '../../lib/utils';

export function CalculatorModal({ open, onOpenChange }) {
  const [display, setDisplay] = useState('0');
  const [memory, setMemory] = useState(null);
  const [operator, setOperator] = useState(null);

  const handleInput = (value) => {
    if (value === 'C') {
      setDisplay('0');
      setMemory(null);
      setOperator(null);
    } else if (value === '=') {
      if (memory !== null && operator) {
        const current = parseFloat(display);
        let result;
        switch (operator) {
          case '+': result = memory + current; break;
          case '-': result = memory - current; break;
          case '×': result = memory * current; break;
          case '÷': result = current !== 0 ? memory / current : 0; break;
          default: result = current;
        }
        setDisplay(result.toString());
        setMemory(null);
        setOperator(null);
      }
    } else if (['+', '-', '×', '÷'].includes(value)) {
      setMemory(parseFloat(display));
      setOperator(value);
      setDisplay('0');
    } else if (value === '.') {
      if (!display.includes('.')) {
        setDisplay(display + '.');
      }
    } else {
      setDisplay(display === '0' ? value : display + value);
    }
  };

  return (
    <Modal open={open} onOpenChange={onOpenChange}>
      <ModalContent size="sm">
        <ModalHeader>
          <ModalTitle className="flex items-center gap-2">
            <Calculator className="h-5 w-5" />
            Calculadora
          </ModalTitle>
        </ModalHeader>
        <ModalBody className="space-y-3">
          <div className="h-14 bg-muted rounded-lg flex items-center justify-end px-4">
            <span className="text-2xl font-mono font-bold">{display}</span>
          </div>
          <div className="grid grid-cols-4 gap-2">
            {['C', '÷', '×', '-', '7', '8', '9', '+', '4', '5', '6', '=', '1', '2', '3', '.', '0'].map((btn) => (
              <Button
                key={btn}
                variant="outline"
                className={cn(
                  'h-12 text-lg font-semibold',
                  ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.'].includes(btn) && 'bg-card',
                  ['+', '-', '×', '÷'].includes(btn) && 'bg-primary/10 text-primary',
                  btn === '=' && 'row-span-2 bg-primary text-primary-foreground hover:bg-primary/90',
                  btn === '0' && 'col-span-2',
                  btn === 'C' && 'bg-destructive/10 text-destructive'
                )}
                onClick={() => handleInput(btn)}
              >
                {btn}
              </Button>
            ))}
          </div>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default CalculatorModal;
